import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'GA_MEASUREMENT_ID', {
        page_path: location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }

    // Track Facebook Pixel
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
    }

    // Track custom events
    const trackEngagement = () => {
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'engagement', {
          event_category: 'User Interaction',
          event_label: location.pathname,
          value: 1
        });
      }
    };

    // Track scroll depth
    const trackScrollDepth = () => {
      const scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
      
      if (scrollPercent >= 25 && !window.scrollTracked25) {
        window.scrollTracked25 = true;
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('event', 'scroll_depth', {
            event_category: 'Engagement',
            event_label: '25%',
            value: 25
          });
        }
      }
      
      if (scrollPercent >= 50 && !window.scrollTracked50) {
        window.scrollTracked50 = true;
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('event', 'scroll_depth', {
            event_category: 'Engagement',
            event_label: '50%',
            value: 50
          });
        }
      }
      
      if (scrollPercent >= 75 && !window.scrollTracked75) {
        window.scrollTracked75 = true;
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('event', 'scroll_depth', {
            event_category: 'Engagement',
            event_label: '75%',
            value: 75
          });
        }
      }
    };

    // Add event listeners
    const timer = setTimeout(trackEngagement, 30000); // Track after 30 seconds
    
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', trackScrollDepth);
    }

    return () => {
      clearTimeout(timer);
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', trackScrollDepth);
      }
    };
  }, [location]);

  return null;
};

export default Analytics;